module.exports = __webpack_public_path__ + "img/upload-orders-logo.c4be8984.svg";